<template>
  <div class="customer-info-content">
    <div class="customer-info top">
      <div class="name" style="margin-bottom: 5px">
        <div>
          {{ $t("page_ops_work_record_document_number") }}{{ detail.code }}
        </div>
        <div v-show="!detail.handlerInfo" class="creat-Pdf" @click="printPdf">
          <a-icon type="file-pdf" /> {{ $t("page_ops_priht_pdf_print_report") }}
        </div>
      </div>
      <a-row class="customer-info-detail">
        <a-col :span="12">
          <span class="lable"
            >{{ $t("page_ops_work_record_customer_name") }}：</span
          ><span class="value">{{ detail.customerName }}</span>
          <span v-if="detail.customerIsDeleted === 1" style="color: red"
            >({{ $t("page_tenant_deleted") }})</span
          >
        </a-col>
        <a-col :span="12">
          <span class="lable">
            {{ $t("page_ops_work_record_resolution_progress") }}：</span
          ><a-tag :color="processProgressColor"
            >{{ detail.processProgress }}
          </a-tag>
        </a-col>
      </a-row>
      <a-row class="customer-info-detail">
        <a-col :span="12">
          <span class="lable"
            >{{ $t("page_ops_work_record_customer_address") }}：</span
          >
          <span class="value">{{ customerAddress }}</span>
        </a-col>
        <a-col :span="12">
          <span class="lable"
            >{{ $t("page_ops_work_record_submit_person") }}：</span
          ><span class="value">{{ detail.submitUserName }}</span>
        </a-col>
      </a-row>
      <a-row class="customer-info-detail">
        <a-col :span="12">
          <span class="lable"
            >{{ $t("page_extranet_Machine_serial_number") }}：</span
          >
          <span class="value">{{ detail.workstationSerialNo }}</span>
          <span v-if="detail.workStationIsDeleted === 1" style="color: red"
            >({{ $t("page_tenant_deleted") }})</span
          >
          <a-button
            type="link"
            v-if="hasExtranetApp"
            @click="gotoExtranet(detail.workstationSerialNo)"
            :disabled="!detail.workstationSerialNo || !extranetEnabled"
          >
            远程连接<a-icon type="link" />
          </a-button>
        </a-col>
        <a-col :span="12">
          <span class="lable">{{ $t("page_ops_machine_machine_name") }}：</span
          ><span class="value">{{ detail.workstationName }}</span>
          <span v-if="detail.workStationIsDeleted === 1" style="color: red"
            >({{ $t("page_tenant_deleted") }})</span
          >
        </a-col>
      </a-row>
      <a-row class="customer-info-detail">
        <a-col :span="12">
          <span class="lable">{{ $t("page_ops_work_record_reporter") }}：</span
          ><span class="value">{{ detail.contactUserName }}</span>
        </a-col>
        <a-col :span="12">
          <span class="lable"
            >{{ $t("page_ops_work_record_contact_information") }}：</span
          ><span class="value">{{ detail.contactInfo }}</span>
        </a-col>
      </a-row>
      <a-row class="customer-info-detail">
        <a-col :span="12">
          <span class="lable">{{ $t("page_ops_customer_email") }}：</span
          ><span class="value">{{ detail.email }}</span>
        </a-col>
        <a-col :span="12">
          <span class="lable">{{ $t("page_ops_customer_wx_account") }}：</span
          ><span class="value">{{ detail.wxAccount }}</span>
        </a-col>
      </a-row>
      <a-row class="customer-info-detail" v-if="detail.workstationId">
        <a-col :span="12">
          <span class="lable"
            >{{ $t("page_ops_machine_model_machine_deliveryTime") }}：</span
          ><span class="value">{{
            getStringDate(detail.workstationDeliveryTime, "YYYY-MM-DD")
          }}</span>
        </a-col>
        <a-col :span="12">
            <span class="lable">{{ $t("page_work_handle_time") }}：</span
            ><span class="value">{{ detail.handleTimeConsuming }}</span>
        </a-col>
      </a-row>
    </div>
    <div class="customer-info">
      <div class="name">
        <div>{{ $t("page_ops_work_record_classified_information") }}</div>
      </div>
      <a-row class="customer-info-detail">
        <a-col :span="12">
          <span class="lable"
            >{{ $t("page_ops_work_record_job_classification") }}：</span
          ><span class="value">{{ detail.jobTypeName }}</span>
        </a-col>
        <a-col :span="12">
          <span class="lable"
            >{{ $t("page_ops_work_record_industry_classification") }}：</span
          ><span class="value">{{ detail.industryTypeName }}</span>
        </a-col>
      </a-row>
    </div>
    <div class="customer-info">
      <div class="name">
        <div>{{ $t("page_ops_work_record_request_detail") }}</div>
      </div>
      <div class="workRecords-body-content-detail">
        <a-row class="customer-info-detail">
          <span class="lable"
            >{{ $t("page_ops_work_record_customer_request") }}：</span
          >
          <span class="value">{{ detail.questionDesc }}</span>
        </a-row>
        <a-row class="customer-info-detail">
          <span class="lable"
            >{{ $t("page_ops_work_record_component_request") }}：</span
          >
          <span class="value">{{ detail.componentDesc || "否" }}</span>
        </a-row>
        <a-row
          class="customer-info-detail"
          style="display: flex"
          v-if="detail.attachList && detail.attachList.length > 0"
        >
          <div class="content-detail-left">
            {{ $t("page_ops_work_record_photo") }}：
          </div>
          <div class="content-detail-right">
            <div v-for="(pic, i) in detail.attachList" :key="i" class="pic-con">
              <img :src="pic ? pic : ''" @click="openGallery(i)" />
            </div>
          </div>
        </a-row>
        <a-row
          class="customer-info-detail"
          style="display: flex"
          v-if="detail.video && detail.video.length > 0"
        >
          <div class="content-detail-left">
            {{ $t("page_ops_work_record_video") }}：
          </div>
          <div class="content-detail-right">
            <a
              :href="item.url"
              style="color: #333333"
              target="_blank"
              v-for="(item, index) in detail.video"
              :key="index"
              class="pic-con"
            >
              <img :src="item.thumb" />
              <a-icon type="play-circle" class="icon" />
            </a>
          </div>
        </a-row>
        <a-row
          v-if="detail.evaluation"
          class="customer-info-detail"
          style="display: flex"
        >
        <span class="lable"
            >{{ $t("page_ops_work_record_evaluation") }}：</span
          >
          <span class="value">{{ evaluationMap[detail.evaluation] }}</span>
        </a-row>
        <a-row
          v-if="detail.signature"
          class="customer-info-detail"
          style="display: flex"
        >
          <div class="content-detail-left">
            {{ $t("page_ops_work_record_signature") }}：
          </div>
          <div class="content-detail-right">
            <div class="pic-con">
              <img
                :src="detail.signature ? detail.signature : ''"
                @click="openGallery(0, [detail.signature])"
              />
            </div>
          </div>
        </a-row>
      </div>
    </div>
    <div class="footer-wapper flex-1 flex">
      <div class="customer-info" style="width: 100%">
        <div class="name" style="margin-bottom: 20px">
          <div>{{ $t("page_ops_work_record_handle_records") }}</div>
        </div>
        <div style="margin-left: 30px">
          <a-timeline v-if="!detail.handlerInfo" class="customer-info-detail" style="flex-direction:column">
            <a-timeline-item
              v-for="(item, index) in processComment"
              :key="index"
              :color="index === 0 ? 'blue' : 'green'"
            >
              <a-icon
                v-if="!isHistory && index === processComment.size - 1"
                slot="dot"
                type="sync"
                spin
              />
              <div
                :class="{
                  'step-title step-title-first': index === 0,
                  'step-title': index != 0,
                }"
              >
                {{ item[1][0].processStepName }}
              </div>
              <div v-for="(data, index) in item[1]" :key="index">
                <span
                  :class="{
                    'step-subTitle-name': index === 0,
                    'step-subTitle-name1': index != 0,
                  }"
                  >{{ data.processUserName }}</span
                >
                <span
                  class="step-subTitle-time"
                  style="color: rgba(0, 0, 0, 0.45)"
                  >{{ getStringDate(data.processTime) }}</span
                >
                <div v-if="IsShowView(data)" class="step-subTitle-button">
                  <a-button type="link" @click="view(data.id)">
                    {{ $t("page_ops_work_record_read_attach") }}
                  </a-button>
                </div>
                <div v-if="IsShowComment(data)" class="step-subTitle-button">
                  <a-button
                    type="link"
                    @click="
                      comment({
                        businessKey: workRecordId,
                        taskId: data.taskId,
                      })
                    "
                  >
                    <a-icon type="plus-circle" />{{
                      $t("page_ops_work_record_add_comments")
                    }}
                  </a-button>
                </div>
                <div class="step-description">{{ data.processComment }}</div>
              </div>
            </a-timeline-item>
          </a-timeline>
          <a-timeline v-if="detail.handlerInfo" class="customer-info-detail">
            <a-timeline-item
              v-for="(item, index) in detail.handlerInfo"
              :key="index"
              :color="index === 0 ? 'blue' : 'green'"
            >
              <div style="display: flex">
                <div style="width: 100px">{{ item.handleName }}</div>
                <div>{{ item.handleTime }}</div>
              </div>
              <div>{{ item.handleInfo }}</div>
            </a-timeline-item>
          </a-timeline>
        </div>
      </div>
    </div>

    <view-model
      :visible="viewModelVisible"
      :attachmentList="attachmentList"
      @cancel="closeViewModel"
    />
    <comment-model
      ref="comment"
      :visible="commentModelVisible"
      @cancel="closeCommentModel"
    />
    <gallery
      v-if="galleryVisible"
      :visible="galleryVisible"
      :imgs="prevImgs"
      :index="imgIndex"
      @cancel="onGalleryCancel"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";
import Gallery from "../../../../../components/Gallery";
import {
  WorkRecordServiceProxy
} from "@/service-proxies/app-v2/work-record.service-proxies";
import CommentModel from "../../list/components/comment.vue";
import { setLocalStorage } from "@/utils/storage";
import {
  DictBizServiceProxy,
  TenantSettingServiceProxy,
  TenantAppServiceProxy,
} from "@/service-proxies/app-v2/system.service-proxies";
import ViewModel from "../../common/components/View.vue";
import { mapActions } from "vuex";
import { getUserInfo } from "@/utils/auth";

import {
  MachineServiceProxy,
} from "@/service-proxies/app-v2/workStation.service-proxies";

const wrsp = new WorkRecordServiceProxy();
const dictServiceProxy = new DictBizServiceProxy();
const tssp = new TenantSettingServiceProxy();
const tasp = new TenantAppServiceProxy();
const machineSrvProxy = new MachineServiceProxy();

export default {
  name: "WorkRecordDetail",
  components: { ViewModel, CommentModel, Gallery },
  props: {
    workRecordId: {
      type: String,
      default: "",
    },
    isHistory: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasExtranetApp() {
      const app = this.appMap.find((res) => res.appCode === "extranet");
      return app != undefined;
    },
    customerAddress() {
      if (!this.detail.customerAddress) {
        return;
      }
      const { provinceName, cityName, address } = this.detail.customerAddress;
      if (provinceName === cityName) {
        return cityName + address;
      } else {
        return provinceName + cityName + address;
      }
    },
  },
  data() {
    return {
      appMap: [],
      // 提交基础信息
      dictList: [],
      enableAddComments: false,
      detail: {},
      processAttachment: new Map(),
      processComment: new Map(),
      finalProcessingCompletionTime: {},
      viewModelVisible: false,
      commentModelVisible: false,
      processProgressColor: "",
      galleryVisible: false, // 是否展示图片集
      currentImgs: [], // 图片集
      prevImgs: [], // 预览图片集
      imgIndex: 1,
      pdfIitem: {},
      attachmentList: [],
      extranetEnabled: true,
      evaluationMap: {1: '一般', 2: '基本满意', 3: '满意', 4: '满意', 5: '非常满意'}
    };
  },
  async created() {
    await this.getStateDict();
  },
  mounted() {
    this.init();
  },
  watch: {
    workRecordId: {
      handler(val) {
        if (!val) {
          this.enableAddComments = false;
          this.detail = {};
          this.processComment = new Map();
          this.finalProcessingCompletionTime = {};
          this.commentModelVisible = false;
          this.processProgressColor = "";
          this.galleryVisible = false; // 是否展示图片集
          this.currentImgs = []; // 图片集
          this.prevImgs = [];
          this.imgIndex = 1;
          this.pdfIitem = {};
          return;
        }
        wrsp.getWorkRecordBriefInfo(val).then((res) => {
          this.pdfIitem = res;
          this.enableAddComments = res.enableAddComments;
          this.detail = res.workRecordDetailVO;
          if (this.detail.video) {
            this.detail.video = JSON.parse(this.detail.video);
          }
          this.currentImgs = this.detail.attachList;
          /**
           * 如果有handleInfo,不渲染评价和附件
           */
          if (!this.detail.handlerInfo) {
            this.processAttachment = this.getMapProcessAttachment(
              res.workRecordProcessAttachmentList
            );
            this.processComment = this.getMapProcessComment(
              res.workRecordProcessCommentList
            );
          } else {
            this.detail.handlerInfo = JSON.parse(this.detail.handlerInfo);
          }
          this.processProgressColor = this.getStateValue(
            this.detail.processProgress
          );
        });
      },
      immediate: true,
    },
    detail: {
      handler(newVal, oldVal) {
        this.refreshExtranet();
      },
    },
  },
  methods: {
    ...mapActions({
      generateRoutes: "permission/generateRoutes",
    }),
    printPdf() {
      let value = [];
      Array.from(this.processComment).forEach((res) => {
        if (res[1] && res[1].length) {
          value = value.concat(res[1]);
        }
      });
      const item = {
        workRecordProcessAttachmentList:
          this.pdfIitem.workRecordProcessAttachmentList,
        workRecordProcessCommentList: value,
        workRecordDetailVO: this.pdfIitem.workRecordDetailVO,
      };
      this.$store.state.workHistoryPrintData = item;
      setLocalStorage("workHistoryPrintData", item);
      this.$nextTick(() => {
        window.open("/ops/pdfPoint");
      });
    },
    getMapProcessAttachment(data) {
      let map = new Map();
      if (data && data.length != 0) {
        data.forEach((item) => {
          let key = item.description;
          if (map.get(key)) {
            let arr = map.get(key);
            arr.push(item);
          } else {
            let arr = [];
            arr.push(item);
            map.set(key, arr);
          }
        });
      }
      return map;
    },
    getMapProcessComment(data) {
      // 将追加评论的数据组合在一起
      let map = new Map();
      if (data.length != 0) {
        for (let i = 0; i < data.length; i++) {
          let key = data[i].taskId + data[i].processStepName;
          if (data[i].processStepName === "处理完成") {
            this.finalProcessingCompletionTime.key = this.getStringDate(
              data[i].processTime
            );
          }
          if (map.get(key)) {
            let arr = map.get(key);
            arr.push(data[i]);
          } else {
            let arr = [];
            arr.push(data[i]);
            map.set(key, arr);
          }
        }
      }
      return map;
    },
    async getStateDict() {
      let res = await dictServiceProxy.dictionary("work_record_status");
      this.dictList = res.data;
    },
    getStateValue(value) {
      let target = this.dictList.find((res) => res.dictValue == value);
      let tagValue = target || { remark: "", dictValue: value };
      return tagValue.remark;
    },
    getStringDate(time, format = "YYYY-MM-DD HH:mm:ss") {
      return time ? dayjs(time).format(format) : "";
    },
    IsShowView(item) {
      return (
        this.processAttachment.get(item.id) &&
        item.processStepName === "处理完成"
      );
    },
    IsShowComment(item) {
      // enableAddComments为true且是最后一条处理完成的记录上面显示追加评论按钮
      return (
        this.enableAddComments &&
        item.processStepName === "处理完成" &&
        this.getStringDate(item.processTime) ==
          this.finalProcessingCompletionTime.key
      );
    },
    view(id) {
      let list = this.processAttachment.get(id);
      this.attachmentList = list;
      this.viewModelVisible = true;
    },
    comment(record) {
      this.$refs["comment"].initData(record);
      this.commentModelVisible = true;
    },
    getData() {
      wrsp.getWorkRecordBriefInfo(this.workRecordId).then((res) => {
        this.processAttachment = this.getMapProcessAttachment(
          res.workRecordProcessAttachmentList
        );
        // 刷新流程信息
        this.processComment = this.getMapProcessComment(
          res.workRecordProcessCommentList
        );
        res.workRecordProcessCommentList.forEach((instance) => {
          if (instance.processStepName === "处理完成") {
            this.finalProcessingCompletionTime.key = this.getStringDate(
              instance.processTime
            );
          }
        });
      });
    },
    closeViewModel(isSuccess) {
      this.viewModelVisible = false;
    },
    closeCommentModel(isSuccess) {
      if (isSuccess) {
        this.getData();
      }
      this.commentModelVisible = false;
    },
    openGallery(index, imgs) {
      this.prevImgs = imgs ? imgs : this.currentImgs;
      this.imgIndex = index;
      this.galleryVisible = true;
    },
    onGalleryCancel() {
      this.galleryVisible = false;
    },
    async init() {
      const userId = this.getUserId();
      const res = await tssp.detailConditions(
        userId,
        "location-label",
        "",
        "",
        "",
        ""
      );
      if (res.length) {
        this.$store.commit("user/SET_DRAWER_ID", res[0].id);
        this.$store.commit(
          "user/SET_DRAWER",
          JSON.parse(res[0].paramValue || "[]")
        );
      }
      const appList = await tasp.getCurrentTenantGrantAPPList(1);

      this.appMap = appList;
    },
    getUserId() {
      const info = getUserInfo();
      return info.user_id || "";
    },
    async gotoExtranet(key) {
      const data = await this.generateRoutes("extranet"); // 动态增加路由
      this.$store.commit("permission/SET_ROUTES", data);
      const app = this.appMap.find((res) => res.appCode === "extranet");

      if (app) {
        this.$store.commit("permission/SET_APP_ROUTE_MAP", {
          appCode: app.appCode,
          appName: app.appName,
          routes: data.length ? data[0].children : [],
        });
      }
      this.$router.addRoutes(
        data.concat({
          path: "*",
          redirect: "/404",
        })
      );
      await this.$router.push({
        path: "/extranet/remote-diagnosis",
        query: {
          key,
        },
      });
    },
    refreshExtranet() {
      if (!this.detail) {
        return;
      }

      const { workstationId } = this.detail;
      if (!workstationId) {
        this.extranetEnabled = false;
        return;
      }
      machineSrvProxy.feature(workstationId).then((res) => {
        this.extranetEnabled = res.hasRemoteConnection;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  border-top: 4px solid #5395ca;
}
.creat-Pdf {
  color: #49d1d1;
  cursor: pointer;
  font-size: 16px;
  font-weight: normal;
}
.customer-info {
  background: #fff;
  padding: 4px 8px;

  .name {
    color: #5395ca;
    font-size: 16px;
    font-weight: bold;
    line-height: 18px;
    border-left: 3px solid #5395ca;
    padding-left: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .customer-info-qr {
      color: #49d1d1;
      cursor: pointer;
    }
  }
  .customer-info-detail {
    display: flex;
    // align-items: center;
    .lable {
      display: inline-block;
      width: 100px;
      text-align: right;
    }
    padding: 9px;

    /deep/.ant-steps-item-title {
      width: 100% !important;
      margin-bottom: 5px;
    }

    .step-title-first {
      color: #4a90e2 !important;
    }
    .step-title {
      float: left;
      display: block;
      width: 80px;
      color: #52c41a;
      font-weight: bold;
    }
    .step-subTitle-name {
      float: left;
      display: block;
      width: 290px;
      margin-left: 50px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .step-subTitle-name1 {
      float: left;
      display: block;
      //margin: 5px 0;
      width: 290px;
      margin-left: 130px;
      white-space: nowrap;
      overflow: hidden;
    }
    .step-subTitle-time {
      margin-left: 5px;
    }
    .step-description {
      margin: 8px 0px 8px 130px;
      word-wrap: break-word;
    }
    .step-subTitle-button {
      float: right;
    }
  }
}

.workRecords-body-content-detail {
  width: 100%;
  min-height: 100px;
  word-wrap: break-word;
  .content-detail-right {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
  }
  .pic-con {
    position: relative;
    cursor: pointer;
    width: 100px;
    height: 100px;
    .icon {
      font-size: 48px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .content-detail-mesg {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 0;
  }
  .content-detail-left {
    width: 100px;
    text-align: right;
  }
  .pic-con img {
    padding: 5px;
    width: 100%;
    height: 100%;
  }
}

.footer-wapper {
  background: #fff;
  height: calc(100% - 202px);
}
</style>
